import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
  beforeLoad: ({ context }) => {
    if (context.auth.user) {
      throw redirect({
        to: "/dashboard",
      })
    }
  },
})

const MESH_BACKGROUND = {
  backgroundColor: "#0B1925",
  backgroundImage: [
    "radial-gradient(at 0% 0%, #0C1525 0px, transparent 50%)",
    "radial-gradient(at 50% 0%, #0B1925 0px, transparent 50%)",
    "radial-gradient(at 100% 0%, #0A295A 0px, transparent 50%)",
    "radial-gradient(at 0% 100%, #153E4B 0px, transparent 50%)",
    "radial-gradient(at 50% 100%, #104C53 0px, transparent 50%)",
    "radial-gradient(at 100% 100%, #087A75 0px, transparent 50%)",
  ].join(", "),
}

function AuthLayout() {
  return (
    <div
      className="relative flex min-h-dvh items-center justify-center overflow-hidden p-6"
      style={MESH_BACKGROUND}
    >
      {/* Decorative elements */}
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_25%,rgba(120,160,210,0.25)_0%,rgba(120,160,210,0)_70%)]"
      />

      {/* Content */}
      <div className="relative z-10 flex w-full flex-col items-center gap-12">
        <img
          src="/dark-logo.png"
          alt="ONEai Health"
          className="h-20 w-auto drop-shadow-2xl"
        />
        <Outlet />
      </div>
    </div>
  )
}
